import type { ValorantServer } from 'generated/openapi';
import { memo } from 'react';

import { useGetValorantPlayer } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import {
  ProfileDetails,
  type ProfileDetailsGameplayHeaderProps,
} from '@/features/profile/components/profileDetails';

export type ProfileGameplayProps = ProfileDetailsGameplayHeaderProps & {
  riotPuuid: string;
  mainValorantAgentId: string;
  servers?: ValorantServer[];
};

export const ProfileGameplay = memo(function ProfileGameplay(
  props: ProfileGameplayProps,
) {
  const { riotPuuid, mainValorantAgentId, servers, ...headerProps } = props;

  const { data: valorantData } = useGetValorantPlayer({
    puuid: riotPuuid,
    options: {
      select: data => data.player,
    },
  });

  return (
    <ProfileDetails.Gameplay.Root>
      <ProfileDetails.Gameplay.Header {...headerProps} />
      <ProfileDetails.Gameplay.PlayerInfo
        region={valorantData.region}
        servers={servers}
        rankedQueueRate={valorantData.stats.rankedQueueRate}
        matchesPlayed={valorantData.matchesPlayed}
        lastPlayedAt={valorantData.lastPlayedAt}
      />
      <ProfileDetails.Gameplay.Rank
        currentRank={valorantData.rank}
        peakRank={valorantData.peakRank}
      />
      <ProfileDetails.Gameplay.MostPlayedAgents
        agents={valorantData.agents}
        mainValorantAgentId={mainValorantAgentId}
      />
      <ProfileDetails.Gameplay.SkillOverview
        damagePerRound={valorantData.stats.damagePerRound}
        kdRatio={valorantData.stats.killToDeathRatio}
        headshotPercentage={valorantData.stats.headshotRate}
        winPercentage={valorantData.stats.winRate}
      />
      <ProfileDetails.Gameplay.SocialOverview
        totalPartymates={valorantData.stats.uniqueTeammateCount}
        repeatingPartymates={valorantData.stats.repeatedTeammateCount}
        partyQueuePercentage={valorantData.stats.partyQueueRate}
      />
    </ProfileDetails.Gameplay.Root>
  );
});
